'use client';
import React, { useState } from 'react';
import DiscoverFilters from './DiscoverFilters';
import ActivityGrid from './ActivityGrid';
import DiscoverHeader from './DiscoverHeader';

export type FilterState = {
  search: string;
  category: string;
  profession: string;
  entryType: string;
  difficulty: string;
  minPrize: number;
  maxEntry: number;
  duration: string;
  sortBy: string;
};

const defaultFilters: FilterState = {
  search: '',
  category: 'All',
  profession: 'All',
  entryType: 'All',
  difficulty: 'All',
  minPrize: 0,
  maxEntry: 1000,
  duration: 'All',
  sortBy: 'trending',
};

export default function DiscoverContent() {
  const [filters, setFilters] = useState<FilterState>(defaultFilters);
  const [filtersOpen, setFiltersOpen] = useState(true);

  const updateFilter = (key: keyof FilterState, value: string | number) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="space-y-5">
      <DiscoverHeader
        filters={filters}
        onUpdateFilter={updateFilter}
        filtersOpen={filtersOpen}
        onToggleFilters={() => setFiltersOpen(!filtersOpen)}
      />

      <div className="flex gap-5">
        {/* Filter panel */}
        {filtersOpen && (
          <div className="hidden lg:block w-64 xl:w-72 flex-shrink-0">
            <DiscoverFilters filters={filters} onUpdateFilter={updateFilter} />
          </div>
        )}

        {/* Activity grid */}
        <div className="flex-1 min-w-0">
          <ActivityGrid filters={filters} />
        </div>
      </div>
    </div>
  );
}